/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandPointIcon16Light } from './HandPointIcon16Light';
import { HandPointIcon16Regular } from './HandPointIcon16Regular';
import { HandPointIcon16Solid } from './HandPointIcon16Solid';
import { HandPointIcon20Light } from './HandPointIcon20Light';
import { HandPointIcon20Regular } from './HandPointIcon20Regular';
import { HandPointIcon20Solid } from './HandPointIcon20Solid';
import { HandPointIcon24Regular } from './HandPointIcon24Regular';
import { HandPointIcon24Solid } from './HandPointIcon24Solid';
import { HandPointIcon32Regular } from './HandPointIcon32Regular';
import { HandPointIcon64Regular } from './HandPointIcon64Regular';
var sizes = {
    16: {
        light: HandPointIcon16Light,
        regular: HandPointIcon16Regular,
        solid: HandPointIcon16Solid,
    },
    20: {
        light: HandPointIcon20Light,
        regular: HandPointIcon20Regular,
        solid: HandPointIcon20Solid,
    },
    24: {
        regular: HandPointIcon24Regular,
        solid: HandPointIcon24Solid,
    },
    32: {
        regular: HandPointIcon32Regular,
    },
    64: {
        regular: HandPointIcon64Regular,
    },
};
export var HandPointIcon = forwardRef('HandPointIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
